require('./layouts/animate')
require('./layouts/draggabilly.pkgd.min')
require('./layouts/imagesloaded.pkgd.min')
require('./layouts/selectize')
require('./layouts/stretchy')
require('./layouts/stretchy.custom')
require('./layouts/swap')
require('./layouts/common')
require('./marketing/pages')
